module.exports = __webpack_public_path__ + "img/66.980be407.jpg";